import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Input, SearchInputV2 } from '../../../common/Forms/Input/Input';
import AffiliationTypeCheckboxList from './AffiliationTypeCheckboxList';
import { useWatch } from 'react-hook-form';

export default function SurchargesForm({
  isOpen,
  onClose,
  onSubmit,
  register,
  errors,
  editingSurchargesId,
  getSalesChannelsByName,
  setValue,
    getValues,
    control,
    clearErrorByFiueldName
}) {
  const [affiliationType, setAffiliationType] = useState([]);
  const [hasSurcharge, setHasSurcharge] = useState(false);
  const [hasDiscount, setHasDiscount] = useState(false);
  const [saleChannel, setSaleChannel] = useState('');

  const handleAffiliationTypeChange = (type) => {
    setAffiliationType((prev) => {
      const newAffiliations = prev.includes(type)
        ? prev.filter((item) => item !== type)
        : [...prev, type];
      setValue('contractTypes', newAffiliations);
      return newAffiliations;
    });
  };

  const handleChangeSurchage = (e) => {
    setHasSurcharge(e.target.checked);
    setValue('useRenewSurcharge', e.target.checked);
  }
  
  const handleChangeDiscount = (e) => {
    setHasDiscount(e.target.checked);
    setValue('useRenewDiscount', e.target.checked);
  }

  const dateFromWatch = useWatch({
    control,
    name: 'dateFrom'
  });

  const contractTypes = useWatch({
    control,
    name: 'contractTypes',
  })
  const saleChannelWatch = useWatch({
    control,
    name: 'saleChannel',
    defaultValue: null,
  })
  const useRenewDiscount = useWatch({
    control,
    name: 'useRenewDiscount',
  })
  const useRenewSurcharge = useWatch({
    control,
    name: 'useRenewSurcharge',
  })

  const closeForm = () => {
    setAffiliationType([]);
    setHasSurcharge(false);
    setHasDiscount(false);
    setSaleChannel('');
    onClose();
  }

  useEffect(() => {
    if (editingSurchargesId) {
      setAffiliationType(contractTypes || []);
      setHasSurcharge(useRenewSurcharge || false);
      setHasDiscount(useRenewDiscount || false);
      setSaleChannel(saleChannelWatch ? saleChannelWatch : '');
    }
  }, [editingSurchargesId, contractTypes, useRenewSurcharge, useRenewDiscount, saleChannelWatch]);

  return (
    <Modal size="lg" centered show={isOpen} onHide={closeForm} className="surcharges-form-modal" onSubmit={onSubmit}>
      <Modal.Header closeButton className="border-bottom-0 pb-0">
        <Modal.Title style={{ fontSize: '18px', fontWeight: '700', color: '#1a1f36' }}>
          {editingSurchargesId ? 'Editar regla de pricing' : 'Nueva regla de pricing'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-3 pb-0 pl-1 pr-1">
        <div id="surcharges-form" style={{ width: '100%' }}>
          {/* SECCIÓN 1: IDENTIFICACIÓN */}
          <div className="surcharges-form__section-title">IDENTIFICACIÓN</div>
          
          <label className="surcharges-form__label">Canal de venta *</label>
          <div className="surcharges-form__input-wrapper">
            <SearchInputV2 
                placeholder="Buscar o seleccionar canal ..."
                searchAction={getSalesChannelsByName}
                value={saleChannel?.name}
                onChange={(e) => {
                  console.log('Selected sale channel:', e.target.value);
                  setSaleChannel(e?.target?.value);
                  setValue('saleChannel', e?.target?.value); 
                  clearErrorByFiueldName('saleChannel');
                }}
                width="100%"
                error={errors?.saleChannel?.message ? "el canal de venta es obligatorio" : null}
            />
          </div>

          <div className="surcharges-form__input-wrapper d-flex justify-content-between gap-3">
            <Input
                bootstrap={'col-12 col-md-5'}
                label={'Fecha de desde *'}
                type={'date'}
                name={'dateFrom'}
                placeholder={''}
                register={register}
                errors={errors?.dateFrom?.message}
                control={control}
                minDate={new Date()} // Fecha actual como mínimo
              />
            <Input
                bootstrap={'col-12 col-md-5'}
                label={'Fecha de hasta *'}
                type={'date'}
                name={'dateTo'}
                placeholder={''}
                register={register}
                errors={errors?.dateTo?.message}
                control={control}
                minDate={dateFromWatch ? new Date(dateFromWatch) : new Date()} // Fecha de desde como mínimo
              />
          </div>

          <AffiliationTypeCheckboxList
            affiliationType={affiliationType}
            handleAffiliationTypeChange={handleAffiliationTypeChange}
            error={errors?.contractTypes?.message}
            clearErrorByFiueldName={clearErrorByFiueldName}
          />

          {/* SECCIÓN 2: REGLAS DE AJUSTE */}
          <div className="surcharges-form__section-title mt-4">REGLAS DE AJUSTE</div>

          <div className="surcharges-form__switch-row">
            <div className="surcharges-form__switch-content">
              <label className="surcharges-form__switch">
                <input 
                  type="checkbox" 
                  checked={hasSurcharge}
                  onChange={handleChangeSurchage}
                />
                <span className="surcharges-form__switch-slider"></span>
              </label>
              <div className="surcharges-form__switch-text">
                <span className="surcharges-form__switch-title">Aplica recargo por siniestralidad</span>
                <span className="surcharges-form__switch-subtitle">Se cobra un monto adicional cuando el cliente tiene historial de siniestros</span>
              </div>
            </div>
            {hasSurcharge ? 
              <span className="surcharges-form__badge surcharges-form__badge--yes">SÍ</span> : 
              <span className="surcharges-form__badge surcharges-form__badge--no">NO</span>
            }
          </div>

          <div className="surcharges-form__switch-row">
            <div className="surcharges-form__switch-content">
              <label className="surcharges-form__switch">
                <input 
                  type="checkbox" 
                  checked={hasDiscount}
                  onChange={handleChangeDiscount}
                />
                <span className="surcharges-form__switch-slider"></span>
              </label>
              <div className="surcharges-form__switch-text">
                <span className="surcharges-form__switch-title">Aplica descuento por siniestralidad/renovación anticipada</span>
                <span className="surcharges-form__switch-subtitle">Descuento según nivel de siniestralidad (Oro, Plata, etc.) del cliente</span>
              </div>
            </div>
            {hasDiscount ? 
              <span className="surcharges-form__badge surcharges-form__badge--yes">SÍ</span> : 
              <span className="surcharges-form__badge surcharges-form__badge--no">NO</span>
            }
          </div>

          <Input
            bootstrap={'col-12'}
            label={'Motivo o nota *'}
            type={'textarea'}
            name={'description'}
            register={register}
            placeholder={"Ej: Contrato marco, Beneficio empleados, etc. Este campo es obligatorio para fines de auditoría."}
            errors={errors?.description?.message}
            rows={5}
          />

        </div>
      </Modal.Body>
      <Modal.Footer className="border-top-0 pt-0 pb-3 pl-3 pr-3">
        <div className="surcharges-form__modal-footer">
          <span className="surcharges-form__footer-text">* Campos obligatorios</span>
          <div className="surcharges-form__footer-actions">
            <button type="button" className="surcharges-form__btn-cancel" onClick={closeForm}>Cancelar</button>
            
            <button type="submit" form="surcharges-form" className="surcharges-form__btn-submit" onClick={onSubmit}>
              {editingSurchargesId ? 'Guardar cambios' : 'Crear regla'}
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
